import React, { useEffect, useState } from "react";
import primaryarrow from "../../images/primary-arrow.svg";
import stars from "../../images/stars.svg";
import { httpApi } from "api/http.api";
import { Spin } from "antd";
import { getAdvancedProfileSummery } from "api/candidate.api";
import RelatedQuestions from "./RelatedQuestions";
import { set } from "lodash";
import TooltipWrapper from "components/CandidateProfile/TooltipWrapper";
import Feedback from "./Feedback";
import { useAppSelector } from "hooks/reduxHooks";

interface CandidateBioComponentProps {
  id?: number;
  isBioEdited?: boolean;
  editorName?: string;
  bio?: any | null;
  isProfile?: boolean;
  candidateNotes?: any;
  tooltipText?: string;
  setAdvanceSummeryOpened?: React.Dispatch<React.SetStateAction<boolean>>;
  setAiBioData?: any;
  setRefresh?: React.Dispatch<React.SetStateAction<boolean>>;
  isListed?: boolean;
  autoLoadAdvancedSummary?: boolean;
}

const CandidateBioComponent: React.FC<CandidateBioComponentProps> = ({
  id,
  isBioEdited,
  editorName,
  bio,
  isProfile,
  candidateNotes,
  tooltipText,
  setAdvanceSummeryOpened,
  setAiBioData,
  setRefresh,
  isListed,
  autoLoadAdvancedSummary = true,
}) => {
  const [summeryOpen, setSummeryOpen] = useState(false);
  const [advanceSummeryOpen, setAdvanceSummeryOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [AIBioData, setAIBioData] = useState<any>(null);
  const [bioOpen, setBioOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<string[]>([]);
  const [bioData, setBioData] = useState<string[]>([]);
  const [error, setError] = useState<any>(null);
  const [readMore, setReadMore] = useState<boolean>(false);

  const selectedCandidates = useAppSelector((state) => state.candidateBulkMail.candidates) || [];

  const getCandidateSummery = async () => {
    if (summeryOpen) {
      setSummeryOpen(false);
      setBioOpen(true);
      return;
    }

    if (data.length === 0 && id) {
      setLoading(true);
      try {
        const response = await httpApi.get(`candidate/profile-summary/${id}/`);
        const summaryData = response?.data.summary || response?.data.ai_summary || [];
        setData(summaryData);
        setError(null);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    setSummeryOpen(true);
    setAdvanceSummeryOpen(false);
    if (!autoLoadAdvancedSummary) {
      setBioOpen(false);
    } else {
      setBioOpen(true);
    }
    setFeedbackOpen(false);
  };

  const handleBioSelect = () => {
    if (bioOpen) {
      setBioOpen(false);
      return;
    }

    // setBioData(bio ? (Array.isArray(bio) ? bio : [bio]) : ["No Bio available. Please click on View AI Summary!"]);
    setBioOpen(true);
    setSummeryOpen(false);
    setAdvanceSummeryOpen(false);
    setFeedbackOpen(false);
  };

  const handleAdvancedSummery = async () => {
    if (advanceSummeryOpen) {
      setAdvanceSummeryOpen(false);
      return;
    }

    // if (id) {
    //   setLoading(true);
    //   try {
    //     const res = await getAdvancedProfileSummery(id);
    //     setAIBioData(res.ai_search);
    //     setError(null);
    //   } catch (error) {
    //     console.error("Error fetching advanced profile summary:", error);
    //     setAIBioData(null);
    //     setError(true);
    //   } finally {
    //     setLoading(false);
    //   }
    // }

    setAdvanceSummeryOpen(true);
    setSummeryOpen(false);
    setBioOpen(false);
    setFeedbackOpen(false);
  };

  const advancedProfileSummary = async () => {
    if (id) {
      setLoading(true);
      try {
        const res = await getAdvancedProfileSummery(id);
        setAIBioData(res.ai_search ?? res);
        if (setAiBioData) setAiBioData(res.ai_search ?? res);
        setError(null);
      } catch (error) {
        console.error("Error fetching advanced profile summary:", error);
        setAIBioData(null);
        if (setAiBioData) setAiBioData(null);
        setError(true);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (typeof id !== "number") return;
    const selectedCandidateSet = new Set(selectedCandidates.map((candidate) => candidate?.id || 0));
    // if (selectedCandidateSet.has(id)) {
    if (autoLoadAdvancedSummary) {
      advancedProfileSummary();
    }
    // advancedProfileSummary();
    // }
  }, [id]);

  useEffect(() => {
    if (bio) {
      try {
        const parsed = JSON.parse(bio);
        if (parsed?.bio) {
          setBioOpen(true);
        } else {
          getCandidateSummery();
          setSummeryOpen(true);
        }
      } catch (error) {
        if (typeof bio === "string") {
          setBioOpen(true);
        } else {
          getCandidateSummery();
          setSummeryOpen(true);
        }
      }
    }
  }, [bio]);

  const handleFeedbackOpen = () => {
    setAdvanceSummeryOpen(false);
    setSummeryOpen(false);
    setBioOpen(false);
    setFeedbackOpen(true);
  };

  useEffect(() => {
    if (setAdvanceSummeryOpened) setAdvanceSummeryOpened(advanceSummeryOpen);
  }, [advanceSummeryOpen]);

  const hasFeedback = candidateNotes?.some((note: any) => note.feedback !== null);

  return (
    <div className="mt-5 border-t border-main-border w-full">
      <div className="flex gap-2 mt-2 px-1.5 py-2 border-b border-dashed">
        {/* Bio Tab */}
        {tooltipText ? (
          <TooltipWrapper text={tooltipText} placement="right">
            <p
              className={`text-sm font-bold cursor-pointer pe-2.5 border-r border-main-border ${
                bioOpen ? "text-primary" : "text-text-heading"
              }`}
              onClick={handleBioSelect}
            >
              Bio
            </p>
          </TooltipWrapper>
        ) : (
          <p
            className={`text-sm font-bold cursor-pointer pe-2.5 border-r border-main-border ${
              bioOpen ? "text-primary" : "text-text-heading"
            }`}
            onClick={handleBioSelect}
          >
            Bio
          </p>
        )}

        {/* AI Summary Tab */}
        {!isProfile && (
          <p
            className={`text-sm font-medium cursor-pointer flex gap-1 ${
              summeryOpen ? "text-primary" : "text-text-heading"
            }`}
            onClick={getCandidateSummery}
          >
            <img src={stars} />
            {summeryOpen ? "Hide AI Summary" : "View AI Summary"}
            {/* {!isProfile && <img src={primaryarrow} />} */}
          </p>
        )}

        {/* Advanced Summary Tab */}
        {/* {isProfile &&
          <p
            className={`text-sm font-medium cursor-pointer flex gap-1 ${advanceSummeryOpen ? "text-primary" : "text-text-heading"}`}
            onClick={handleAdvancedSummery}
          >
            <img src={stars} />
            {advanceSummeryOpen ? "Hide Advance Summary" : "View Advance Summary"}
          </p>} */}
        {/* {tooltipText && (
            <TooltipWrapper text={tooltipText} placement="right" >
              <></>
            </TooltipWrapper>
            )}*/}
        {candidateNotes && candidateNotes.length > 0 && hasFeedback && (
          <p
            className={`text-sm font-medium cursor-pointer ps-2.5 border-l border-main-border flex gap-1 ${
              feedbackOpen ? "text-primary" : "text-text-heading"
            }`}
            onClick={handleFeedbackOpen}
          >
            Feedback
          </p>
        )}
        {/* )}  */}
      </div>

      <Spin spinning={loading} size="small" className="min-h-10">
        {/* Bio Content */}
        {bioOpen && (
          // <div className="bg-[#F9F5FF] mt-1 p-5">
          <div className="mt-1 p-5 bg-[#F9F5FF]">
            {/* {bioData.map((item, index) => (
              <p key={index} className="text-text-secondary text-sm font-normal">
                {item}
              </p>
            ))} */}
            <RelatedQuestions
              isListed={isListed}
              isBioEdited={isBioEdited}
              editorName={editorName || ""}
              candidateId={id || 0}
              bio={bio || ""}
              error={error}
              AIBioData={AIBioData}
              loading={loading}
              setRefresh={setRefresh}
              bgColor="bg-gray-50"
            />
          </div>
        )}

        {/* AI Summary Content */}
        {summeryOpen && (
          <div
            className={`overflow-y-hidden bg-[#F9F5FF] mt-1 ${data.length > 0 ? "p-5" : "max-h-0"}`}
          >
            {error && <p className="text-red-500">Error loading summary</p>}
            {data.length > 0 ? (
              <p className="text-text-secondary text-sm font-normal">
                {readMore ? (
                  data.map((item, index) => (
                    <span key={index}>
                      {item}
                      <br />
                    </span>
                  ))
                ) : (
                  <>
                    {data[0]}
                    {data.length > 1 && (
                      <span
                        className="text-primary cursor-pointer"
                        onClick={() => setReadMore(true)}
                      >
                        {" "}
                        Read More
                      </span>
                    )}
                  </>
                )}
              </p>
            ) : (
              !loading && <p className="text-text-secondary">No summary available</p>
            )}
          </div>
        )}

        {/* Advanced Summary Content */}
        {/* {advanceSummeryOpen && (
          <RelatedQuestions error={error} AIBioData={AIBioData} loading={loading} />
        )} */}
        {feedbackOpen && candidateNotes && <Feedback candidateNotes={candidateNotes} />}
      </Spin>
    </div>
  );
};

export default CandidateBioComponent;
